import { useLanguage } from "@/context/LanguageContext";
import { LogoFull } from "@/components/Logo";
import { buildWaLink, WA_DISPLAY, EMAIL } from "@/lib/whatsapp";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#0B1320] text-[#FAF9F6]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="bg-[#FAF9F6] rounded-2xl p-4 inline-block">
              <LogoFull />
            </div>
            <p className="mt-6 max-w-md text-[#FAF9F6]/70 text-base leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-[#FF5A00] mb-5">
              {t("footer.contact")}
            </h4>
            <ul className="space-y-4 text-[#FAF9F6]/85">
              <li>
                <a
                  data-testid="footer-whatsapp-link"
                  href={buildWaLink(t("whatsapp.msg_default"))}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-3 hover:text-[#FF5A00] transition-colors"
                >
                  <Phone size={18} strokeWidth={2} />
                  <span dir="ltr">{WA_DISPLAY}</span>
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${EMAIL}`}
                  className="inline-flex items-center gap-3 hover:text-[#FF5A00] transition-colors"
                >
                  <Mail size={18} strokeWidth={2} />
                  <span>{EMAIL}</span>
                </a>
              </li>
              <li className="inline-flex items-center gap-3">
                <MapPin size={18} strokeWidth={2} />
                <span>Al Muruj, Riyadh</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-[0.18em] text-[#FF5A00] mb-5">
              {t("footer.hours")}
            </h4>
            <p className="text-[#FAF9F6]/85">{t("footer.hours_val")}</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#FAF9F6]/10 text-sm text-[#FAF9F6]/50">
          <span>© {new Date().getFullYear()} Talibnaz · Al Muruj, Riyadh</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
